export default __webpack_public_path__ + "static/media/cardframeimage.93905481e344480adc2530341791f1de.webp";